import type { ActionType } from 'typesafe-actions';

import type * as actions from './actions';

export enum Resource {
  PayableById = 'payableById',
}

export type LoadingAction = ActionType<typeof actions>;

export interface LoadingState {
  isLoadingByResource: Record<Resource, boolean>;
}
